import SideModal from "components/SideModal";
import { useTranslation } from "contexts/i18nContext";
import { useToast } from "contexts/ToastContext";
import { ChangeEvent, useState } from "react";
import {
  addChargeDocFeedbackByCouncil,
  editComplaint,
  editInvestigation,
} from "services/prosecutorDecipilineService";
import { Complaints, Investigation } from "types";
import { LoadingIcon } from "utils/constant";
import { COMPLIANT_STATUS, INVESTIGATION_STATUS } from "utils/constantValues";
import "../styles/AddEvidenceModal.css";

interface FeedbackModalProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  complaintData: Complaints;
  investigationData: Investigation;
  onRefresh: any;
}

export default function AddChargeBackFeedbackModal({
  isOpen,
  setIsOpen,
  complaintData,
  investigationData,
  onRefresh,
}: FeedbackModalProps) {
  const { t } = useTranslation();
  const { showToast } = useToast();
  const [loading, setLoading] = useState(false);
  // const [error, setError] = useState<string | null>(null);
  // const [success, setSuccess] = useState(false);

  const [formState, setFormState] = useState({
    feedback: "",
  });

  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>,
  ) => {
    const { name, value } = e.target;
    setFormState((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    // setError(null);
    // setSuccess(false);

    if (!investigationData?.uu_id) {
      showToast(t("investigationNotFound"), "error");
      return;
    }

    const data = {
      ...formState,
      status: INVESTIGATION_STATUS.BACK_TO_PROSECUTOR,

      admin_unit_id: complaintData.admin_unit_id || "",
      org_id: complaintData.org_id || "",

      accused_prosecutor_name: complaintData?.accused_prosecutor_name || "",
      user_id_accused_prosecutor_name:
        complaintData?.user_id_accused_prosecutor_name || "",
      accused_prosecutor_org_id: complaintData?.accused_prosecutor_org_id || "",
      accused_prosecutor_admin_unit_id:
        complaintData?.accused_prosecutor_admin_unit_id || "",
      assigned_prosecutor: complaintData?.user_id_accused_prosecutor_name || "",
      user_id_assigned_prosecutor:
        complaintData?.user_id_accused_prosecutor_name || "",
      complaint: complaintData?.uu_id || null,
    };
    const investigation_id = investigationData?.uu_id || "";
    const isFormData = false;

    try {
      const resData = await editInvestigation(
        data,
        investigation_id,
        isFormData,
      );

      if (resData) {
        await addChargeDocFeedbackByCouncil({
          investigation: investigation_id,
          comment: formState.feedback,
        });
      }

      if (resData) {
        await editComplaint({
          ...(complaintData as Complaints),
          has_councile: true,
          status: COMPLIANT_STATUS.RETURNED,
        });
      }

      onRefresh();
      setIsOpen(false);
      showToast(t("successfullyCreated"), "success");
      // setSuccess(true);
      setFormState({
        feedback: "",
      });
    } catch (err: any) {
      console.error("Submission error:", err);
      showToast(t("submissionError"), "error");
      // setError(
      //     err?.response?.data?.message || err.message || "Something went wrong."
      // );
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <SideModal isOpen={isOpen} setIsOpen={setIsOpen} title={t("addFeedback")}>
      <form onSubmit={handleSubmit} className="evidence-form">
        <section className="evidence-section">
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              {t("feedback")}
            </label>
            <textarea
              required
              rows={7}
              name="feedback"
              value={formState.feedback}
              onChange={handleChange}
              placeholder={t("detailsHere")}
              className="w-full border bg-gray-100 rounded-md p-2 text-sm"
            />
          </div>
        </section>

        <button
          type="submit"
          className="bg-black w-full text-white px-6 py-2 rounded-md hover:bg-gray-800"
          disabled={loading}
        >
          {loading ? (
            <div className="flex items-center justify-center">
              {LoadingIcon}
              {t("submitting")}
            </div>
          ) : (
            t("addFeedback")
          )}
        </button>
      </form>
    </SideModal>
  );
}
